<div class="view-as-modal-container">
  <div class="text-left go-back d-block">
    <button disableRipple mat-button class="delete-user p-0" (click)="goBack()">
      <mat-icon matPreffix>arrow_back_ios</mat-icon>
      Go Back
    </button>
  </div>
  <h6 class="modal-title">Set Filter:</h6>
  <div class="row form-container">
    <div class="col-12 col-sm-9 col-sm-offset-1">
      <app-dynamic-form
        *ngIf="data.questions"
        [questions]="data.questions"
        [disabled]="false"
        (formSubmit)="onSubmit($event)"
      >
      </app-dynamic-form>
    </div>
  </div>
</div>
